import {
  CAPABILITIES,
  CAPABILITY_MIN_ROLE,
  type Capability,
} from '@brew/auth/rbac'

export const MEMBER_ACCESS_REQUIRED_COPY =
  'You do not have access to this brand. Ask an organization admin to add you to it.'

/** Permission explanations are derived from the same policy as enforcement. */
export const CAPABILITY_DENIED_COPY = Object.fromEntries(
  CAPABILITIES.map((capability) => [
    capability,
    CAPABILITY_MIN_ROLE[capability] === 'org_admin'
      ? 'Organization admin access is required.'
      : MEMBER_ACCESS_REQUIRED_COPY,
  ])
) as Readonly<Record<Capability, string>>
